var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "card w-modal h-modal", attrs: { id: "donation-payment" } },
    [
      _c("div", { staticClass: "header" }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [_c("i", { staticClass: "icn icn-x sm" })]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSendingSms,
              expression: "isSendingSms"
            }
          ],
          staticClass: "content"
        },
        [
          _c("div", { staticClass: "flex flex-col items-center" }, [
            _c("img", {
              staticClass: "h-40 mb-14 mt-20",
              attrs: { src: require("@/assets/img/loading.svg") }
            }),
            _c("div", { staticClass: "flex flex-col items-center" }, [
              _c("h1", { staticClass: "mb-10" }, [
                _vm._v(
                  "Sending a text message to " +
                    _vm._s(_vm.payload.supporter.phoneNumber)
                )
              ])
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isWaitingForPayment,
              expression: "isWaitingForPayment"
            }
          ],
          staticClass: "content"
        },
        [
          _c("div", { staticClass: "flex flex-col items-center" }, [
            _c("img", {
              staticClass: "h-40 mb-14 mt-20",
              attrs: { src: require("@/assets/img/loading.svg") }
            }),
            _c("div", { staticClass: "flex flex-col items-center" }, [
              _c("h1", { staticClass: "mb-10" }, [
                _vm._v(
                  "A text message has been sent to " +
                    _vm._s(_vm.payload.supporter.phoneNumber)
                )
              ]),
              _c("h1", [
                _vm._v("Waiting for the supporter to finalise the payment")
              ]),
              _vm.remotePaymentToken
                ? _c("h3", { staticClass: "mt-10" }, [
                    _vm._v(
                      " Last SMS is sent at: " +
                        _vm._s(
                          _vm._f("moment")(_vm.remotePaymentToken.createdAt)
                        ) +
                        " "
                    )
                  ])
                : _vm._e(),
              !_vm.cooldown && !_vm.isResending && _vm.isAbleToResend
                ? _c(
                    "button",
                    {
                      staticClass: "primary mt-2",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.resendToken()
                        }
                      }
                    },
                    [_vm._v(" Resend SMS ")]
                  )
                : _vm._e(),
              _vm.cooldown
                ? _c(
                    "button",
                    {
                      staticClass: "secondary mt-2",
                      attrs: { disabled: "", type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.resendToken()
                        }
                      }
                    },
                    [
                      _vm._v(
                        " Resend SMS in " + _vm._s(_vm.cooldown) + " seconds "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "flex flex-col" }, [
        _c("h1", { staticClass: "mb-2" }, [_vm._v("New Donation")]),
        _c("div", { staticClass: "flex flex-row" }, [
          _c("h4", { staticClass: "opacity-50" }, [_vm._v("Donation Details")]),
          _c("h4", { staticClass: "ml-4 mr-4 opacity-50" }, [_vm._v(">")]),
          _c("h4", { staticClass: "opacity-50" }, [
            _vm._v("Supporter Details")
          ]),
          _c("h4", { staticClass: "ml-4 mr-4" }, [_vm._v(">")]),
          _c("h4", [_vm._v("Payment")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }